import React, { useState, useEffect } from "react"
import { Box, TextField } from "@mui/material"
import { Cancel as Close, Block } from "@material-ui/icons"
import { typeAPI } from "../../services/TypeAPI"
import Swal from "sweetalert2"
import "./box.css"

const Path = ({ list, setDel, dir, path }) => {
    const [search, setSearch] = useState("")

    const filterSearch = (result) => {
        try {
            if (search != "") return result.match(new RegExp(`^${search}.*$`))
            else return true
        } catch (error) {
            console.log(error)
            return true
        }

    }
    const [sliceZ, setSliceZ] = useState(10)
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (Array.isArray(list)) {
            setData(list)
        }
        return () => {
            setData([])
        }
    }, [list])

    const DeleteFile = (rez) => {
        Swal.fire({
            title: `ยืนยันที่จะลบไฟล์ ${rez} ?`,
            confirmButtonColor: "#6ab23a",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "OK!",
        })
            .then((result) => {
                if (result.isConfirmed) {
                    setLoading(true)
                    typeAPI.DeleteFile({ path1: dir, path2: path, name: rez })
                        .then((res) => {
                            if (res.status == 200 || res.status == 404) {
                                let index = data.findIndex((res) => res == rez)
                                if (index >= 0) {
                                    let del = data.filter((res, i) => i != index)
                                    setData(del)
                                    setDel((old) => old + 1)
                                }
                            }
                            else {
                                Swal.fire({
                                    icon: 'error',
                                    confirmButtonColor: "#6ab23a",
                                    text: `${res.message}`,
                                    timer: 5000
                                })
                            }

                        })
                        .catch((error) => {
                            Swal.fire({
                                icon: 'error',
                                confirmButtonColor: "#6ab23a",
                                text: `${error.message}`,
                                timer: 5000
                            })
                        })
                        .finally(() => {
                            setLoading(false)
                        })
                }
            })

    }

    return (
        <>
            <TextField style={{ marginLeft: '10px' }} label="พิมพ์ชื่อไฟล์ที่ค้นหา" value={search} onChange={(e) => setSearch(e.target.value)} variant="standard" />
            <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '5px' }}>
                {Array.isArray(data) && <> {data.filter(filterSearch).slice(0, sliceZ).sort((a, b) => a.name - b.name).map((rez, i) => (
                    <Box className="containerPath" key={i}>
                        {!loading ? <Close className="x" onClick={() => DeleteFile(rez)} /> : <Block className="x" />}
                        {rez}
                    </Box>
                )
                )}
                    {data.length >= 10 && <Box
                        style={{ border: '1px solid lightgray', borderRadius: '8px', margin: '5px', padding: '5px', cursor: 'pointer', fontSize: '14px', backgroundColor: 'black', color: 'white' }} disabled={sliceZ >= data.length} onClick={() => setSliceZ((old) => old + 10)}>ดูเพิ่มเติม </Box>}
                </>}</div>
        </>
    )
}

export default Path